export default __webpack_public_path__ + "static/media/bh_logo.f1c05f23.png";